import { useParams } from 'react-router-dom';
import TourLandingTemplate from './TourLandingTemplate';
import tourData from '../data/tourStops.json';
import stopPhotos from './stopPhotos';

function TourStop() {
  const { stopId } = useParams();

  // Find the tour stop from the JSON data
  const stop = tourData.tourStops.find(s => s.id === stopId);

  if (!stop) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>Tour Stop Not Found</h1>
        <p>Sorry, we couldn't find this tour stop.</p>
      </div>
    );
  }

  return (
    <TourLandingTemplate
      location={`${stop.city}, ${stop.state}`}
      date="Tour of a Lifetime - Summer 2026"
      photo={stopPhotos[stop.id]}
      photoAlt={`Tour of a Lifetime stop in ${stop.city}, ${stop.state}`}
      flickrUrl={stop.flickrUrl}
    />
  );
}

export default TourStop;
